import { useIsDesktop } from '@cian/valuation-utils-component';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { TABS } from './utils/constants';
import { trackTabClick } from './utils/tracking';
import { setPageType } from '../../actions';
import { updateQueryString } from '../../actions/page/updateQueryString';
import { Layout } from '../../components/Layout';
import { Tabs } from '../../components/Tabs';
import { selectPageType, selectQueryParams } from '../../selectors';
import { EPageType } from '../../types/page/pageType';

export const TabsContainer: React.FC = () => {
  const dispatch = useDispatch();
  const isDesktop = useIsDesktop();

  const { source } = useSelector(selectQueryParams);
  const pageType = useSelector(selectPageType);
  const siteType = isDesktop ? 'desktop' : 'mobile';

  const onPageTypeChange = React.useCallback(
    (val: EPageType) => {
      dispatch(setPageType(val));
      dispatch(updateQueryString());
      trackTabClick({
        dealType: val,
        cianSource: source,
        siteType,
      });
    },
    [dispatch, siteType],
  );

  return (
    <Layout>
      <Tabs tabs={TABS} pageType={pageType} onChange={onPageTypeChange} />
    </Layout>
  );
};
